import type { FaireProductEntity } from "../../entity_types/product";

export const p_vtv6nnrkuh: FaireProductEntity = {
  token: "p_vtv6nnrkuh",
  type: "product",
  name: "Bigfoot Cows Spaceship Ufo Abduction Socks",
  brandToken: "b_5xdelgfsdc",
  brandName: "Gypsy Rose",
  imageUrl:
    "https://cdn.faire.com/fastly/d3273cab89e5ca1a70d7764a89487c290ee14988fe541acbde962a09fbbd8580.png",
  galleryImageUrls: [],
  priceDollars: 8,
  description:
    "Boldly go where no sock has gone before with the Bigfoot Cows Spaceship UFO Abduction Socks!\n\n• Showcases a detailed Bigfoot silhouette mid-abduction by a flying saucer\n• Crafted from a soft, breathable cotton blend for all-day comfort\n• One size fits most adults\n• Easy machine wash and dry\n\nEmbark on an intergalactic adventure for your feet with these out-of-this-world socks! Whether you're a Bigfoot believer or just love a good alien abduction story, these socks are sure to pique curiosity and start conversations. Slip them on and let your toes explore the mysteries of the cosmos - no rocket ship required. Embrace your inner extraterrestrial and make a statement with these must-have socks.",
  tags: [],
  msrpDollars: 16,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-05-05T00:27:29.101Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
